import apis from './apis';
import type { ResearchIntent } from '../components/Research/types';

/**
 * Research prompt library (F-PROMPT): the user's saved prompts plus the ones
 * an org admin has shared with the firm. Backed by /research/prompts.
 */

export interface ResearchPrompt {
  uuid: string;
  title: string;
  body: string;
  intent?: ResearchIntent | null;
  is_org_wide: boolean;
  is_mine: boolean;
  can_edit: boolean;
  use_count: number;
  last_used_at?: string | null;
  updated_at?: string | null;
}

export interface ResearchPromptInput {
  title: string;
  body: string;
  intent?: ResearchIntent | null;
  is_org_wide?: boolean;
}

const unwrap = <T>(data: any): T => (data && data.data !== undefined ? data.data : data) as T;

/** Most used first. */
export async function listResearchPrompts(): Promise<ResearchPrompt[]> {
  const res = await apis.get('/research/prompts');
  return unwrap<ResearchPrompt[]>(res.data) || [];
}

export async function createResearchPrompt(input: ResearchPromptInput): Promise<ResearchPrompt> {
  const res = await apis.post('/research/prompts', input);
  return unwrap<ResearchPrompt>(res.data);
}

export async function updateResearchPrompt(
  uuid: string, input: Partial<ResearchPromptInput>,
): Promise<ResearchPrompt> {
  const res = await apis.put(`/research/prompts/${uuid}`, input);
  return unwrap<ResearchPrompt>(res.data);
}

export async function deleteResearchPrompt(uuid: string): Promise<void> {
  await apis.delete(`/research/prompts/${uuid}`);
}

/** Counts a use so the library sorts by what people reach for. Fire and forget. */
export function recordResearchPromptUse(uuid: string): void {
  apis.post(`/research/prompts/${uuid}/use`, {}).catch(() => undefined);
}
